/**
 * 응답 수 보여주는 컴포넌트
 */
import { memo, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { numberFormat } from 'utils'
import { SurveyAnalysisEndResponseProps } from 'gql/survey_analysis_users'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CachedIcon from '@material-ui/icons/Cached'
import Tooltip from 'styled/Custom/Tooltip'
import { Props as ParentProps } from './ListItemResponseCount'

interface Props {
    survey_no: number;
    loading: boolean;
    today_end_count: SurveyAnalysisEndResponseProps['today_end_count'];
    end_count:  SurveyAnalysisEndResponseProps['end_count'];
    onLocation: ParentProps['onLocation'];
    onClick: () => void;
}

const useStyles = makeStyles(theme => ({
    badge: {
        position: 'absolute',
        color: 'white',
        top: 0,
        right: 0,
        height: 21,
        fontSize: 12,
        borderRadius: 3,
        boderTopLeftRadius: 0,
        boderBottomRightRadius: 0,
        zIndex: 1,
        minWidth: 80,
        textAlign: 'center',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        background: 'yellow'
    },
    badgeText: {
        background: theme.palette.secondary.light,
        height: '100%',
        flexGrow: 1,
        paddingLeft: 5,
        paddingRight: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    badgeIcon: {
        background: theme.palette.secondary.dark,
        borderTopRightRadius: 3,
        height: '100%',
        width: 25,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}))

let timer: ReturnType<typeof setTimeout>

function ListItemResponseCountTextComponent(props: Props) {
    const { survey_no, loading, today_end_count, end_count, onLocation, onClick } = props

    const classes = useStyles()

    const { formatMessage: f } = useIntl()

    const [ newLoading, setNewLoading ] = useState(loading)

    // 무분별하게 클릭하는것을 방지하기위해
    const handleClick = () => {
        if (loading) return

        setNewLoading(true)
        clearTimeout(timer)
        timer = setTimeout(() => {
            onClick()
        }, 800)
    }

    // 로딩이 끝났으면 상태값 false
    useEffect(() => {
        if (!loading) setNewLoading(false)
    }, [loading])

    return (
        <Tooltip title={f({id: 'component.Survey.Workspace.Body.ListItem.response'})}>
            <div className={classes.badge}>
                <Typography 
                    variant="caption" 
                    className={classes.badgeText}
                    onClick={() => onLocation({type: 'analysis', hash: 'tab=rows', survey_no})}
                >
                    {`${numberFormat(today_end_count)} | ${numberFormat(end_count)}`}
                </Typography>
                <div className={classes.badgeIcon} onClick={handleClick}>
                    {
                        newLoading ? <CircularProgress style={{ color: 'white', width: 14, height: 14, display: 'block', cursor: 'default' }} /> :  <CachedIcon fontSize="small" style={{ width: 15, height: 15, display: 'block', cursor: 'pointer' }} />
                    }
                </div>
            </div>
        </Tooltip>
    )
} 

export default memo(ListItemResponseCountTextComponent)